import { render, staticRenderFns } from "./DetailReferralCampaign.vue?vue&type=template&id=1fb2dfa6&scoped=true"
import script from "./DetailReferralCampaign.vue?vue&type=script&lang=js"
export * from "./DetailReferralCampaign.vue?vue&type=script&lang=js"
import style0 from "./DetailReferralCampaign.vue?vue&type=style&index=0&id=1fb2dfa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2dfa6",
  null
  
)

export default component.exports